import React from 'react';
import Error from './Error.js';
import Success from './Success.js';
import Warning from './Warning.js';
const Messages = (props) => {
    switch (props.type) {
        case 'error':
            return React.createElement(Error, { style: props.style, messages: props.messages });
        case 'warning':
            return React.createElement(Warning, { style: props.style, messages: props.messages });
        case 'success':
            return React.createElement(Success, { style: props.style, messages: props.messages });
        default:
            return React.createElement(Success, { style: props.style, messages: props.messages });
    }
};
export default Messages;
//# sourceMappingURL=Messages.js.map